import { Injectable } from "@angular/core";
import { DebitorModelView } from "../types/DebitorModel";
import { StandortModelView } from "../types/StandortModel";
import { ObjektModelView } from "../types/ObjektModel";
import { RoofareaModelView } from "../types/RoofareaModel";
import { SicherungssystemModelView } from "../types/SicherungssystemModel";

@Injectable({
    providedIn: 'root'
})
export class MemoryService {
    public Debitor: DebitorModelView | null = null;
    public Standort: StandortModelView | null = null;
    public Objekt: ObjektModelView | null = null;
    public Roofarea: RoofareaModelView | null = null;
    public Sicherungssystem: SicherungssystemModelView | null = null;

    public getDebitior(lis: DebitorModelView[]): DebitorModelView | null {
        var item = lis.find(x => x.DebitorID == this.Debitor?.DebitorID);
        if (item == null && lis.length == 1) item = lis[0]
        return item ?? null;
    }

    public getStandort(lis: StandortModelView[]): StandortModelView | null {
        var item = lis.find(x => x.StandortID == this.Standort?.StandortID);
        if (item == null && lis.length == 1) item = lis[0]
        return item ?? null;
    }

    public getObjekt(lis: ObjektModelView[]): ObjektModelView | null {
        var item = lis.find(x => x.ObjektID == this.Objekt?.ObjektID);
        if (item == null && lis.length == 1) item = lis[0]
        return item ?? null;
    }

    public getRoofarea(lis: RoofareaModelView[]): RoofareaModelView | null {
        var item = lis.find(x => x.RoofareaID == this.Roofarea?.RoofareaID);
        if (item == null && lis.length == 1) item = lis[0]
        return item ?? null;
    }

    public getSicherungssystem(lis: SicherungssystemModelView[]): SicherungssystemModelView | null {
        var item = lis.find(x => x.SicherungssystemID == this.Sicherungssystem?.SicherungssystemID);
        if (item == null && lis.length == 1) item = lis[0]
        return item ?? null;
    }
}
